export default __webpack_public_path__ + "static/media/Shah Stinger.fdbaa9c7.jpg";